import React from 'react';
import Interest from '../../../Components/Components.Rijon/Interest';
const InterestRate = () => {

    return (
        <Interest></Interest>

    );
};

export default InterestRate;